import styled from '@emotion/styled';

export const Container = styled.div`
  max-width: 1300px;
  margin: 0px auto;
  padding: 20px;
`;
